<template>
    <div>
        <tb-skeleton v-if="!initialized" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

        <div v-else-if="supplier">
            <div class="alert alert-info">Fält markerade med <span class="text-danger">*</span> behövs för beställningarna</div>
            <ValidationObserver ref="supplierform">
                <form @submit.prevent="saveSupplier">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Leverantör <span class="text-danger">*</span></label>
                                        <ValidationProvider vid="Name" name="Name" rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="supplier.Name" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Leverantör, förkortning</label>
                                        <ValidationProvider vid="ShortName" name="ShortName" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="supplier.ShortName" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Kundnummer <span class="text-danger">*</span></label>
                                <ValidationProvider vid="CustomerNr" name="CustomerNr" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="supplier.CustomerNr" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Telefon</label>
                                        <ValidationProvider vid="Phone" name="Phone" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="supplier.Phone" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Fax</label>
                                        <ValidationProvider vid="Fax" name="Fax" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="supplier.Fax" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Epost <span class="text-danger">*</span></label>
                                <ValidationProvider vid="Email" name="Email" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="supplier.Email" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="text-muted">Använd kommatecken (,) för att separera flera e-postmottagare</span>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="form-group">
                                <label>Webbsida</label>
                                <ValidationProvider vid="URL" name="URL" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="supplier.URL" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="form-group">
                                <label>Interna noteringar</label>
                                <ValidationProvider vid="internalNotes" name="internalNotes" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <elastic-textarea class="form-control" style="resize: horizontal; min-height: 357px;" v-model="supplier.internalNotes" v-bind:class="{ 'border-danger':errors[0] }"></elastic-textarea>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="card">
                                <div class="card-header bg-light">
                                    <h6 class="card-title">Adress</h6>
                                </div>
                                <div class="card-body">
                                    <div class="form-group">
                                        <label>Adress <span class="text-danger">*</span></label>
                                        <ValidationProvider vid="Address" name="Address" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="supplier.Address" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <div class="form-group">
                                                <label>Postnummer <span class="text-danger">*</span></label>
                                                <ValidationProvider vid="ZipCode" name="ZipCode" rules="" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="supplier.ZipCode" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="col-lg-8">
                                            <div class="form-group">
                                                <label>Postort <span class="text-danger">*</span></label>
                                                <ValidationProvider vid="City" name="City" rules="" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="supplier.City" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Land <span class="text-danger">*</span></label>
                                        <ValidationProvider vid="City" name="City" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <country-filter
                                                    v-model="supplier.CountryCode"
                                                    placeholder="Land"
                                                    :reduce="opt => opt.id"
                                                    :class="{ 'has-validation-error': errors[0] }"
                                                ></country-filter>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header bg-light">
                                    <h6 class="card-title">Kontaktperson</h6>
                                </div>
                                <div class="card-body">
                                    <div class="form-group">
                                        <label>Namn <span class="text-danger">*</span></label>
                                        <ValidationProvider vid="ContactName" name="ContactName" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="supplier.ContactName" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group">
                                        <label>Telefon</label>
                                        <ValidationProvider vid="ContactPhone" name="ContactPhone" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="supplier.ContactPhone" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group">
                                        <label>Mobilnummer</label>
                                        <ValidationProvider vid="ContactMobile" name="ContactMobile" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="supplier.ContactMobile" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group">
                                        <label>Epost</label>
                                        <ValidationProvider vid="ContactEmail" name="ContactEmail" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="supplier.ContactEmail" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>

                            <div v-if="parseInt(supplier.ProdSupplierID, 10) > 0" class="card">
                                <div class="card-header bg-light header-elements-inline">
                                    <h6 class="card-title">Inloggningsuppgifter</h6>
                                    <div class="header-elements">
                                        <button type="button" class="btn btn-light btn-sm" :disabled="busy_loading_credentials" @click="toggleCredentials">
                                            <i :class="credentials_visible ? 'icon-cross2' : 'icon-eye'" class="mr-1"></i>
                                            {{ credentials_visible ? 'Dölj' : 'Visa' }}
                                        </button>
                                    </div>
                                </div>
                                <div v-if="credentials_visible" class="card-body">
                                    <tb-skeleton v-if="busy_loading_credentials" :height="80" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>
                                    <ValidationObserver v-else ref="credentialsform">
                                        <form @submit.prevent="saveCredentials">
                                            <div class="form-group">
                                                <label>Användarnamn</label>
                                                <ValidationProvider vid="Username" name="Användarnamn" rules="" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="credentials.Username" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                            <div class="form-group">
                                                <label>Lösenord</label>
                                                <ValidationProvider vid="Password" name="Lösenord" rules="" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="credentials.Password" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                            <div class="d-flex justify-content-end">
                                                <limitless-button ref="btnsavecredentials" type="submit" :busy="busy_saving_credentials" icon="icon-floppy-disk">Spara</limitless-button>
                                            </div>
                                        </form>
                                    </ValidationObserver>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </ValidationObserver>

            <div class="d-flex justify-content-end">
                <limitless-button ref="btnsavesupplier" type="button" @click="saveSupplier" :busy="busy_saving" icon="icon-floppy-disk">Save</limitless-button>
            </div>
        </div>
        <div v-else-if="not_found">
            <i>Leverantören finns inte</i>
        </div>
        <div v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import ElasticTextarea from '@components/ElasticTextarea';
import CountryFilter from '@components/Filters/CountryFilter';

export default {
    name: 'SupplierEdit',
    components: {
        ElasticTextarea,
        LimitlessButton,
        CountryFilter,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy_saving: false,
        busy_loading_credentials: false,
        busy_saving_credentials: false,
        not_found: false,
        supplier: null,
        credentials_visible: false,
        credentials: {
            Username: '',
            Password: '',
        },
    }),
    mounted() {
        this.init();
    },
    watch: {
        id() {
            this.init();
        },
    },
    methods: {
        init() {
            this.credentials_visible = false;
            this.credentials = {
                Username: '',
                Password: '',
            };
            this.getSupplier();
        },
        getSupplier() {
            apiClient.get('/vue/suppliers/' + this.id + '')
                .then((response) => {
                    this.supplier = response.data;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                });
        },
        async saveSupplier() {
            const isValid = await this.$refs.supplierform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/suppliers/' + this.id, this.supplier)
                    .then((response) => {
                        if (parseInt(this.id, 10) !== response.data.ProdSupplierID) {
                            window.location.href = '/suppliers/' + response.data.ProdSupplierID;
                        }
                        this.supplier = response.data;
                        this.$refs.btnsavesupplier.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.supplierform.setErrors(parsederror);
                        }
                        this.$refs.btnsavesupplier.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        toggleCredentials() {
            if (this.credentials_visible) {
                this.credentials_visible = false;
                return;
            }

            this.getCredentials();
        },
        getCredentials() {
            this.busy_loading_credentials = true;
            this.credentials_visible = true;

            apiClient.get('/vue/suppliers/' + this.id + '/credentials')
                .then((response) => {
                    this.credentials = {
                        Username: response.data.Username || '',
                        Password: response.data.Password || '',
                    };
                })
                .catch(() => {
                    this.credentials_visible = false;
                })
                .finally(() => {
                    this.busy_loading_credentials = false;
                });
        },
        async saveCredentials() {
            const isValid = await this.$refs.credentialsform.validate();
            if (isValid) {
                this.busy_saving_credentials = true;
                await apiClient.post('/vue/suppliers/' + this.id + '/credentials', this.credentials)
                    .then((response) => {
                        this.credentials = {
                            Username: response.data.Username || '',
                            Password: response.data.Password || '',
                        };
                        this.$refs.btnsavecredentials.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.credentialsform.setErrors(parsederror);
                        }
                        this.$refs.btnsavecredentials.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving_credentials = false;
                    });
            }
        },
    },
};

</script>
